//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getDebugFlag } from '~/plugins/get-debug-cookies'

export default {
  name: 'MobileGeolocation',
  data() {
    return {
      status: 'locating',
      loading: true,
      qaBypass: false,
      menu: [],
      logoTapCount: 0,
      logoTapTimer: null,
    }
  },

  watch: {
    '$route'(to, from) {
      if (to.path === from.path) return

      const locationSuccessAt = localStorage.getItem('location_success_at')
      const checkedRecently = locationSuccessAt &&
          luxon.DateTime.now().minus({ hours: 1 }).valueOf() < parseInt(locationSuccessAt)

      if (!checkedRecently) {
        this.handleGeolocation()
      }
    }
  },

  async mounted() {
    await this.handleGeolocation()
    document.addEventListener('visibilitychange', this._onVisibilityChange)
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this._onVisibilityChange)
  },

  computed: {
    visible: {
      get() {
        return _.get(this.$store.state, 'showLocation', false)
      },
      set(value) {
        this.$store.commit('setLocationStatus', value)
      }
    }
  },

  methods: {
    async _onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        localStorage.removeItem('location_success_at')
        await this.handleGeolocation()
      }
    },

    handleLogoTap() {
      this.logoTapCount++
      clearTimeout(this.logoTapTimer)
      this.logoTapTimer = setTimeout(() => { this.logoTapCount = 0 }, 2000)
      if (this.logoTapCount >= 5) {
        this.logoTapCount = 0
        this.$router.push('/cookies-activation/')
      }
    },

    async handleGeolocation() {
      if (!process.client) return

      const currentLocale = window.localStorage.getItem('app_lang')
      if (currentLocale) {
        this.$i18n.setLocale(currentLocale)
        this.$root.$emit('update_lang')
      }

      this.$store.commit('auth/storeAccessToken', null)

      const isBypassCookie = this._getQABypassCookie()
      const isBypassRoute  = this.$route.path.includes('/cookies-activation/')

      if (isBypassCookie || isBypassRoute) {
        this.qaBypass = true
        console.warn(`[QA] Location bypass active via ${isBypassRoute ? 'route' : 'cookie'}`)
        await this.performLogin()
        this.visible = false
        return
      }

      const locationSuccessAt = localStorage.getItem('location_success_at')
      if (locationSuccessAt) {
        if (luxon.DateTime.now().minus({ hours: 1 }).valueOf() < parseInt(locationSuccessAt)) {
          await this.performLogin()
          this.visible = false
          return
        }
      }

      if (this.system === 'app') {
        this.visible = true
        this.$root.$emit('splash_hide')
        await this.checkRestriction()
      }
    },

    _getQABypassCookie() {
      return getDebugFlag('disable-geolocation')
    },

    _isAndroid() {
      return /android/i.test(navigator.userAgent)
    },
    _isIOS() {
      return /iphone|ipad|ipod/i.test(navigator.userAgent)
    },

    _storageGet(key) {
      return localStorage.getItem(key)
    },
    _storageSet(key, value) {
      localStorage.setItem(key, value)
    },

    _getCurrentPosition(options = {}) {
      return new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          return reject(new Error('Geolocation not supported'))
        }
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          timeout: options.timeout || 10000,
          maximumAge: options.maximumAge || 0,
          enableHighAccuracy: false,
        })
      })
    },

    async _checkPermissions() {
      if (!navigator.permissions) {
        // Fallback: attempt to get position to infer state
        try {
          await this._getCurrentPosition({ timeout: 3000 })
          return 'granted'
        } catch (e) {
          return e.code === 1 ? 'denied' : 'prompt'
        }
      }
      const result = await navigator.permissions.query({ name: 'geolocation' })
      // result.state: 'granted' | 'denied' | 'prompt'
      return result.state
    },

    async performLogin() {
      const response = await this.$auth().get('/api/common/get-location', {})
      if (!_.get(response, 'data.status')) {
        this.status = 'error'
        this.visible = true
        return
      }

      const login_mode = this._storageGet('login_mode')
      if (login_mode === 'auto' || login_mode === 'biometric') {
        setTimeout(() => {
          this.$root.$emit('login_force')
        }, 1000)
      }
    },

    async checkLocation() {
      try {
        await this._getCurrentPosition({ timeout: 1000, maximumAge: 10000 * 10000 })
      } catch (e) {
        console.warn('getCurrentPosition:', e.message)
      }

      const permState = await this._checkPermissions()
      console.log('permissions state:', permState)

      if (permState === 'granted') {
        await this.checkRestriction()
      } else if (permState === 'denied') {
        this.status = 'denied'
      } else {
        this.status = 'request_permissions'
      }
    },

    async checkRestriction() {
      this.status = 'locating'

      const response =  await this.$auth().get('/api/common/get-location', {})

      if (_.get(response, 'data.status')) {
        this.$config.OPERATOR_API      = _.get(response, 'data.config.api_url', '')
        this.$config.OPERATOR_API_LANG = _.get(response, 'data.config.api_lang', '')
        this.$config.OPERATOR_DOMAIN   = _.get(response, 'data.config.domain', '')
        this.$root.$emit('update_config')

        this._storageSet('location_success_at', luxon.DateTime.now().valueOf())
        this.$root.$emit('splash_hide')
        await this.performLogin()

        setTimeout(() => {
          try {
            if (this.system === 'app') this.$CapacitorPush.subscribeToNotifications()
          } catch (e) {}

          this.visible = false
          if (this.$config.GLOBAL_IFRAME.indexOf('staging') > -1) {
            alert(this.$config.GLOBAL_IFRAME)
          }
        }, 1500)
      } else {
        this.status = 'error'
      }
    },

    async allow() {
      try {
        await this._getCurrentPosition()
      } catch (e) {}

      const permState = await this._checkPermissions()
      if (permState === 'granted') {
        await this.checkRestriction()
      } else if (permState === 'denied') {
        this.status = 'denied'
      }
    },

    async retryLocation() {
      if (this.platform === 'web') {
        await this.checkRestriction()
        return
      }

      const permState = await this._checkPermissions()
      if (permState === 'denied') {
        const confirmed = window.confirm('Please enable location services before retrying')
        if (confirmed) {
          await this.openSettings()
        }
      } else {
        await this.checkLocation()
        await this.allow()
      }
    },

    async openSettings() {
      // Native settings deep-link is not available without Capacitor.
      // On iOS/Android the best fallback from a WebView is to prompt the user.
      alert('Please open your device Settings and enable Location for this app, then return and retry.')
    },
  },
}
